import { useEnmonServices } from 'containers/services';
import { useAppNotifications } from 'hooks';
import type { GetLicensesAnalysisResponse, GetLicensesAnalysisArg } from 'lib/services';
import { type UseQueryResult, useQuery } from 'react-query';
import { QUERY_KEYS } from 'utils/queryKeys';

export const useLicensesAnalysis = (filter: GetLicensesAnalysisArg): UseQueryResult<GetLicensesAnalysisResponse> => {
  const { analysisApiClient } = useEnmonServices();
  const notify = useAppNotifications();

  return useQuery(
    QUERY_KEYS.customers.licensesAnalysis(filter),
    async ({ signal }) => await analysisApiClient.getLicenses(filter, signal),
    {
      retry: false,
      onError: error =>
        notify.error({
          type: 'error',
          message: 'There was an error while fetching licenses analysis data',
          description: error instanceof Error ? error.message : undefined,
        }),
    },
  );
};
